module.exports = __webpack_public_path__ + "static/Sonyax59-9cc303a42b59fa48d84c52124f691777.png";